interface SettingsProps {
  onNavigate: (page: 'terms' | 'privacy') => void
}

export default function Settings({ onNavigate }: SettingsProps) {

  return (
    <div className="pb-20 pt-2">
      <div className="container mx-auto px-3 max-w-2xl">
        <h2 className="text-xl font-bold text-white mb-4 text-center">
          Settings
        </h2>

        <div className="space-y-4">
          {/* About Section */}
          <div className="glass-card rounded-2xl p-4">
            <h3 className="text-sm font-bold text-white mb-2">
              About BaseVibe
            </h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              Daily crypto market sentiment tracker built on Base. Vote once per day and build your streak! 🔥
            </p>
          </div>

          {/* Legal Links */}
          <div className="glass-card rounded-2xl p-2">
            <h3 className="text-sm font-bold text-white px-2 py-2 mb-1">
              Legal
            </h3>
            <div className="space-y-1">
              <button
                onClick={() => onNavigate('terms')}
                className="flex items-center justify-between w-full p-2 rounded-xl hover:bg-white/10 transition-colors text-left group"
              >
                <span className="text-sm text-gray-300 group-hover:text-white transition-colors">Terms of Service</span>
                <svg
                  className="h-4 w-4 text-gray-500 group-hover:text-white transition-colors"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
              <button
                onClick={() => onNavigate('privacy')}
                className="flex items-center justify-between w-full p-2 rounded-xl hover:bg-white/10 transition-colors text-left group"
              >
                <span className="text-sm text-gray-300 group-hover:text-white transition-colors">Privacy Policy</span>
                <svg
                  className="h-4 w-4 text-gray-500 group-hover:text-white transition-colors"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Version */}
          <div className="text-center pt-4">
            <p className="text-xs text-gray-600">
              Version 0.1.0 (Beta)
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

